module.exports = __webpack_public_path__ + "img/CS-ECONew_Overview-ECSt_1.c6898ca7.jpg";